
<template>

    <section class="mentor-calendar">

        <div class="calendar-wrapper" v-if="eventsLoaded">
            <full-calendar ref="calendar" :self="self" :config="config" :header="calendarHeader" :events="calendarEvents"></full-calendar>
        </div>

        <div class="schedule-modal" id="schedule-modal">

            <i id="hide-schedule-modal" class="fa fa-close"></i>
            <h4 class="text-center">Add Production Schedule Span</h4>
            <div class="form-group">
                <input placeholder="Name" class="form-control" id="schedule-name">
            </div>
            <div class="form-group">
                <select class="form-control" id="schedule-projects">
                    <option default selected value="">Select Project</option>
                     <option
                     v-for="project in projects"
                     :style="{backgroundColor: project.color}"
                     :value="project.id">{{project.name}}</option>
                 </select>
            </div>
            <div class="form-group">
                <input type="hidden" :value="feed" id="feed">
                <input type="hidden" id="schedule-start">
                <input type="hidden" id="schedule-end">

                <button id="add-schedule" class="btn btn-success">Add</button>
            </div>
        </div>

        <div class="edit-modal" v-if="meetingToEdit" @click="meetingToEdit = null">
           <form @click.stop class="text-center">
                    <h3>Edit Live Session</h3>
                    <span class="date">This live session is scheduled for {{meetingToEdit.start | longDate}}</span>
                    <ul class="buttons">
                        <li>
                            <button
                                @click.prevent="meetingToEdit.reschedule = !meetingToEdit.reschedule"
                                class="btn btn-success">
                            Reschedule
                            </button>
                        </li>
                        <li><button @click.prevent="deleteMeeting()" class="btn btn-success delete">Delete</button></li>
                    </ul>
                    <div v-if="meetingToEdit.reschedule">
                        <select class="form-control" v-model="meetingToEdit.participants" multiple>
                            <option v-for="student in students" :value="student.id">{{student.firstName}} {{student.lastName}}</option>
                        </select>
                        <date-picker  :date="meetingToEdit.date" :option="dateOptions"></date-picker>
                        <button class="btn btn-success" @click.prevent="updateMeeting()">Save</button>
                    </div>


           </form>
        </div>

    </section>

</template>

<script>

import notes from '../../services/mentors/notes';
import schedules from '../../services/mentors/schedules';
import meetings from '../../services/meetings';
import users from '../../services/users';
import globalMeetings from '../../services/global-meetings';

import moment from 'moment';
import tinygradient from 'tinygradient';
import DatePicker from 'vue-datepicker';
import toastr from 'toastr';
import jquery from 'jquery'
import 'jquery-ui-bundle';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';


window.$ = window.jQuery = jquery


export default {
    props: ['projects', 'feed','members'],
    data() {
        return {
            calendarEvents: null,
            eventsLoaded: false,
            groups: null,
            students: null,
            meetingToEdit: null,
            locations: [
                {id:'green_lab', name:'Characters for Film (Green Lab)'},
                {id:'orange_lab', name:'Texturing (Orange Lab)'},
                {id:'blue_lab', name:'Characters for Games (Blue)'},
                {id:'fish_bowl', name:'Fish Bowl'},
                {id:'black_lab', name:'Black Lab'},
                {id:'penthouse_north', name:'Penthouse North'},
                {id:'penthouse_south', name:'Penthouse South'}
            ],
            dateOptions: {
                    type: 'min',
                    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    format: 'YYYY-MM-DD HH:mm',
                    placeholder: 'Start Date',
                    inputStyle: {
                      'border': 'none',
                    },
                    timeoption: {
                        type: 'min',
                        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
                        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                        format: 'YYYY-MM-DD HH:mm'
                    },
                    color: {
                      header: '#363636',
                      headerText: '#3cf'
                    },
                    buttons: {
                      ok: 'Ok',
                      cancel: 'Cancel'
                    },
                    overlayOpacity: 0.5,
                    dismissible: true,
                    limit: [{
                        type: 'weekday',
                        available: [1, 2, 3, 4, 5]
                    }]
            },
            config: {
                defaultView: 'month',
                droppable: true,
                dragRevertDuration: 0,
                displayEventTime: false,
                selectable: true,
                unselectAuto: false,
                eventDurationEditable: true,
                self:self,
                firstDay: 1,
               // editable:true,
                select: function(start, end) {
                    if (end.diff(start, "days") < 2) return;

                    $('#schedule-start').val(start.toDate());
                    $('#schedule-end').val(end.toDate());
                    $('#schedule-modal').show();
                },
                viewRender: function (view, element) {
                    var self = $('#calendar').fullCalendar('option', 'self');
                    self.$bus.$emit('calendarChanged', view.start);
                },
                eventAfterAllRender: function() {
                    var container = document.querySelector(".fc-scroller");
                    container.scrollTop = container.scrollHeight;
                },
                eventRender: function(event, element) {

                    var self = $('#calendar').fullCalendar('option', 'self');
                    element.find('.fc-title').html(event.title);

                    if (event.type === 'meeting' && event.global !== true) {

                        $(element).addClass('no-click');
                        $(element).addClass('gradient');
                        if (localStorage.roles.includes('Mentor')) {
                            element.append('<i class="fa fa-pencil edit"></i>');
                        }
                    }

                    if (event.type === 'dot') {
                        let projectIds = event.projectIds.map(function(p) { return [p]})
                        projectIds.forEach(function(id) {
                            element.append('<span class="dot" style="background-color:' + self.noteColor(id) + '"></span>');
                        });
                    }
                    if (event.type === 'schedule') {
                        if (event.color !== "#363636") {
                            $(element).addClass('gradient');
                        }
                    }
                    if (event.type === 'due') {
                        $(element).addClass('due');
                        if (event.projectIds.length > 0) {
                            let gradient = self.gradient(event.projectIds);
                            $(element).addClass('gradient').css('background',gradient);
                        }
                        if (event.completed === true) {
                            $(element).addClass('completed');
                        }


                    }

                    element.bind('dblclick', function() {


                        if (event.type === 'dot' || event.type === 'meeting') {
                            return false;
                        }

                        if (!event.id) {
                            toastr.error('Please reload the calendar page before deleting');
                            return;
                        }

                        if (event.type === 'due') {

                            var yes = confirm('Are you sure you want to delete this?');
                            if (yes) {
                                let note = {
                                    type: 'dueDate',
                                    noteId: parseInt(event.id),
                                    dueDate: null
                                }
                                notes.update(null, note);
                                $('#calendar').fullCalendar('removeEvents',event._id);
                            }
                        }
                        else {
                            var yes = confirm('Are you sure you want to delete this?');
                            if (yes) {
                                schedules.delete(null, event.id);
                                $('#calendar').fullCalendar('removeEvents',event._id);
                            }
                        }
                      });

                },
                eventMouseover: function(event, mouseEven) {
                    if (event.recordingProcessing === true) {

                        var tooltip = '<div class="tooltipevent" style="width:100px;height:40px;text-align:center;color:#fff;border-radius:4px;background:#444;position:absolute;z-index:10001;">Recording Processing</div>';
                        var $tooltip = $(tooltip).appendTo('body');

                        $(this).mouseover(function(e) {
                            $(this).css('z-index', 10000);
                            $tooltip.fadeIn('500');
                            $tooltip.fadeTo('10', 1.9);
                        }).mousemove(function(e) {
                            $tooltip.css('top', e.pageY + 10);
                            $tooltip.css('left', e.pageX + 20);
                        });
                     }
                },


                eventMouseout: function(event, mouseEven) {
                    $(this).css('z-index', 8);
                    $('.tooltipevent').remove();
                },
                eventClick: function(event, mouseEvent) {
                    var self = $('#calendar').fullCalendar('option', 'self');
                    if (event.type === 'meeting') {
                          if(!event.className.includes('meeting')) {
                              mouseEvent.stopPropagation();
                              mouseEvent.preventDefault();
                           }
                        if ($(mouseEvent.target).hasClass('edit')) {
                            self.meetingToEdit = {
                                _id: event._id,
                                id: event.id,
                                start: event.start.toDate(),
                                date: {
                                    time: event.start.format('YYYY-MM-DD HH:mm')
                                },
                                reschedule: false,
                                participants: event.participants,
                                location: event.location
                            };
                        } else {
                            if (!event.location) {
                                if (event.global === true) {
                                    globalMeetings.recordAttendance(event.id);
                                }
                                else {
                                    meetings.recordAttendance(event.id);
                                }
                                if (!event.recordingProcessing) {
                                    if(!event.className.includes('meeting')) {
                                        window.open( event.url, '_blank' );
                                    }
                                }
                            }
                        }
                    }
                    if (event.type === 'dot' || event.type === 'due') {
                        self.$parent.$emit('goToId', event.id, event.start);
                    }

                },
                eventResize: function(event) {

                        let schedule = {
                            start: moment(event.start).toDate(),
                            end: moment(event.end).toDate(),
                            feed: $('#feed').val()
                        }

                        schedules.update(null, schedule, event.id);
                },

                eventDrop: function(event, delta, revert) {
                    var self = $('#calendar').fullCalendar('option', 'self');

                    if (event.type === 'dot') {
                        revert();
                        return;
                    }

                    if (event.type === 'meeting') {
                        if (localStorage.roles.includes('Mentor')) {
                            let session = {
                                startTime: {
                                    time: event.start,
                                },
                                meetingId: event.id,
                                timezone: moment.tz.guess(),
                                group: event.group,
                                location: event.location
                            }

                            meetings.update(this, session).then(function(response) {

                                if (response.data.success === true) {
                                    toastr.success('Live Session updated');

                                } else {
                                    toastr.error('Error updating session');
                                }
                            })
                        }
                        else {
                            revert();
                        }
                        return;
                    }

                    if (event.type === 'schedule') {

                        let schedule = {
                            start: moment(event.start).toDate(),
                            end: moment(event.end).toDate(),
                            feed: $('#feed').val()
                        }

                        schedules.update(null, schedule, event.id);

                    } else {

                        if (event.createdAt > event.start) {
                            toastr.error('Due date cannot be before start date');
                            revert();
                            return false;
                        }

                        self.$nextTick(function() {
                            let note = {
                                type: 'dueDate',
                                noteId: parseInt(event.id),
                                dueDate:event.start.endOf('day').toDate()
                            }

                            notes.update(null, note);
                        })
                    }
                },
                drop: function(date, jsEvent, ui, resourceId) {
                    var noteId = parseInt($(this).attr('data-id'));

                    var createdAt = moment($(this).attr('data-created'));

                    if (createdAt > date) {
                        toastr.error('Due date cannot be before start date');
                        return;
                    }
                    var calendar = $('#calendar').fullCalendar('getCalendar');

                    var clientEvents = calendar.clientEvents();
                    var alreadyAdded = clientEvents.find(function(c) { return c.id == noteId + '_due'});


                    if (alreadyAdded) {
                        $('#calendar').fullCalendar('removeEvents', alreadyAdded);
                    }

                    let note = {
                        type: 'dueDate',
                        noteId: noteId,
                        dueDate:date.endOf('day').toDate()
                    }


                    notes.update(null, note)
                },

            },
            calendarHeader: {
                left:   'today prev,next',
                center: 'title',
                right:  ''
            }

        }
    },
    components: {DatePicker},
    mounted() {
        var self = this;
        this.config.self = self;
        this.groupMembers = [];

        if (!Array.isArray(this.members)) {
            Object.keys(this.members).forEach(function(m) {
                self.members[m].forEach(function(member) {
                    self.groupMembers.push(member);
                });
            });
        } else {
            this.groupMembers = this.members;
        }

        this.students = this.groupMembers.filter(function(m) { return !m.roles.includes('Mentor')});

        this.getEvents().then(function() {
            self.getGroups().then(function() {
                self.getProductionSchedules().then(async function() {

                    if (localStorage.roles.includes('Admin')) {
                        self.eventsLoaded = true;
                    } else {
                        await self.getGlobalMeetings();
                        self.getMeetings();
                    }
                })
            })
        });


        self.$bus.$on('reloadGlobalMeetings', async function() {

            $('#calendar').fullCalendar('removeEvents', function(e) {
                return e.global === true;
            });

            self.calendarEvents = self.calendarEvents.filter((e)=> {
                return e.global !== true;
            });

            await self.getGlobalMeetings();
        });

        self.$bus.$on('addMentorMeeting', function(m) {
            if (!m.id) { return }

            var calendar = $('#calendar').fullCalendar('getCalendar');
            let clientEvents = calendar.clientEvents();

            const alreadyAdded = clientEvents.find(c => c.id === m.id);

            if (alreadyAdded) {
                return;
            }

            let title;

            if (m.location) {
               title = self.locations.find(function(l) { return l.id === m.location}).name + '\r\n';
            } else {
                title = "Live Session\r\n"
            }

            title = title + moment(m.startTime).local().format('h:mm a');

            if (localStorage.roles.includes('Mentor')) {

                m.participants
                .filter(function(p) { return p != localStorage.user_id})
                .forEach(function(p) {
                    let member = self.members.find(function(m) { return m.id == p});
                    title += "\r\n" + member.firstName + ' ' + member.lastName;
                });
            }

            let meeting = {
                id: m.id,
                type:'meeting',
                group:m.group,
                participants: m.participants,
                start: moment(m.startTime).local().toDate(),
                end: moment(m.startTime).add(m.duration,'minutes').toDate(),
                title: title,
                color: '#3cf',
                textColor:'#1a1a1a',
                html:true
            }

            if (m.location) meeting.location = m.location;

            if (m.archiveUrl) {
                if (m.archiveStatus === 'completed') {
                    meeting.url = m.archiveUrl;
                }
                else if (m.archiveStatus === 'processing') {
                    meeting.title = 'Archive Processing';
                    meeting.url = m.joinUrl;
                }
            } else {
                if (m.joinUrl) meeting.url = m.joinUrl;
            }


            $('#calendar').fullCalendar('renderEvent', meeting);


        })

        this.sockets.subscribe('noteAdded', (data) => {
            let note = data.message;
            if (note.feed != self.feed) return;

            let event = {
                id: note.id,
                start: moment.tz(note.createdAt, moment.tz().guess),
                type: 'dot',
                color:'transparent',
                projectIds: note.projectIds
            }

            $('#calendar').fullCalendar('renderEvent', event);

        });

        this.sockets.subscribe('noteDeleted', (data) => {
            let note = data.message;
            var calendar = $('#calendar').fullCalendar('getCalendar');
            let clientEvents = calendar.clientEvents();

            let events = clientEvents.filter(function(n){ return n.id == data.message.id || n.id == data.message.id + '_due'});

            events.forEach(function(event) {
                $('#calendar').fullCalendar('removeEvents',event._id);
            })

        });

        this.sockets.subscribe('noteUpdated', (data) => {

            let note = data.message;

            if (note.feed != self.$parent.feed) return;

            if (note.dueDate) {

                var calendar = $('#calendar').fullCalendar('getCalendar');
                let clientEvents = calendar.clientEvents();

                let dueExists = clientEvents.findIndex(function(n) {
                    return n.id === note.id + '_due';
                });

                if (dueExists === -1) {

                    let due = {
                        type: 'due',
                        id: note.id + '_due',
                        start: moment.tz(note.dueDate,moment.tz.guess()),
                        color: '#363636',
                        className: 'due',
                        completed: note.completed,
                        projectIds: note.projectIds,
                        end: moment.tz(note.dueDate,moment.tz.guess()),
                        createdAt: moment.tz(note.createdAt, moment.tz().guess)
                    }

                    if (note.tasks && note.tasks.length > 0) {
                        due.title = note.tasks[0].name.substring(0,20);
                    } else {
                        due.title = note.text.substring(0,20);
                    }

                    $('#calendar').fullCalendar('renderEvent', due);
                } else {
                    clientEvents[dueExists].color = self.noteColor(note.projectIds);
                    clientEvents[dueExists].start = note.dueDate;
                    clientEvents[dueExists].end = note.dueDate;
                    clientEvents[dueExists].completed = note.completed;

                    $('#calendar').fullCalendar('updateEvent', clientEvents[dueExists]);
                }
                if (note.feed == localStorage.user_id) {
                    self.$bus.$emit('mentorNoteAdded', {type: 'note', completed: note.completed, title: note.text.substring(0,20), dueDate: note.dueDate, id: note.id});
                }


            }

        //    $('#calendar').fullCalendar('renderEvent', event);

        });

        $('#hide-schedule-modal').click(function(e) {
            $('#schedule-modal').hide();
        });

        $('#add-schedule').click(function(e) {
            e.preventDefault();

            if ($('#schedule-name').val() === '') {
                toastr.error('Please provide a name');
                return false;
            }
            let data = {
                start: $('#schedule-start').val(),
                end: $('#schedule-end').val(),
                name: $('#schedule-name').val().trim(),
                feed: $('#feed').val(),
                projectId: $('#schedule-projects').find(':selected').val()
            }
            schedules.create(null, data).then(function(response) {

                if (response.data.success === true) {
                    $('#schedule-modal').hide();
                    $('#schedule-name').val(null);

                    let item = {
                        title: response.data.schedule.name,
                        start: moment.tz(response.data.schedule.start, moment.tz().guess),
                        end: moment.tz(response.data.schedule.end, moment.tz().guess),
                        color: '#363636',
                        allDay: true,
                        editable:true
                    }

                    if (response.data.schedule.projectId) {
                        item.color = self.noteColor([response.data.schedule.projectId]);
                        item.className = 'gradient';
                    }


                    $('#calendar').fullCalendar('renderEvent', item, true);


                }
            });
        });


    },
    methods: {
        mapEvents(events) {
            var self = this;
            var calendarEvents = [];

            events.forEach(function(e) {
               if (e.dueDate) {
                   let due = {
                        type: 'due',
                        id: e.id + '_due',
                        start: e.dueDate,
                        color: '#363636',
                        className: 'due',
                        completed: e.completed,
                        projectIds: e.projectIds,
                        end: e.dueDate,
                        createdAt: moment.tz(e.createdAt, moment.tz().guess)
                    }


                    if (e.tasks && e.tasks.length > 0) {
                        due.title = e.tasks[0].name.substring(0,20);
                    } else {
                        due.title = e.text.substring(0,20);
                    }

                    calendarEvents.push(due)

                    if (e.feed == localStorage.user_id) {
                        self.$bus.$emit('mentorNoteAdded', {type: 'note', completed: due.completed, title: due.title, dueDate: e.dueDate, id: e.id})
                    }
                } else {

                    let event = {
                        id: e.id,
                        start: moment.tz(e.createdAt, moment.tz().guess),
                        type: 'dot',
                        color:'transparent',
                        projectIds: e.projectIds
                    }
                    // if (moment(e.createdAt).format('YYYY-MM-DD') == '2018-09-18') {
                    //     console.log(e);
                    // }
                    calendarEvents.push(event);
                }

            });
            return calendarEvents;
        },
        getEvents() {
            var self = this;
            let query = '?feed=' + this.feed + '&calendar=true';
            return new Promise(function(resolve, reject) {
                notes.get(self, query).then(function(response) {
                    self.calendarEvents = self.mapEvents(response.data.notes);

                    resolve();
                });
            });
        },
        getProductionSchedules() {
            var self = this;
            self.eventsLoaded = false;
            return schedules.get(this, this.feed).then(function(response) {
                let productionSchedules = response.data.schedules.map(function(s) {
                    let item = {
                        type:'schedule',
                        id: s.id,
                        title: s.name,
                        start: moment.tz(s.start, moment.tz().guess),
                        end: moment.tz(s.end, moment.tz().guess),
                        color: '#363636',
                        allDay: true,
                        editable:true
                    }

                    if (s.projectId) {
                        item.color = self.noteColor([s.projectId]);
                    }
                    return item;
                });
                if (!self.calendarEvents) self.calendarEvents = [];
                self.calendarEvents = self.calendarEvents.concat(productionSchedules);

                return true;


            })
        },
        getGroups() {
            var self = this;
            return new Promise(function(resolve, reject) {
                    users.getGroups(this).then(function(response) {
                    self.groups = response.data.groups;
                    self.$store.dispatch('populate', {type: 'groups', data: response.data.groups});
                    resolve();
                })
            });
        },
        updateMeeting() {
            var self = this;
            var calendar = $('#calendar').fullCalendar('getCalendar');

            var clientEvents = calendar.clientEvents();

            let index = clientEvents.findIndex(function(n) {
                return n.id == self.meetingToEdit.id;
            });

            let userGroups = localStorage.group.split(',').map(function(i) { return parseInt(i)});

            let currentTermGroup = this.$store.getters.groups.findIndex(function(g) {
                return g.term == self.$store.getters.currentTerm.id && userGroups.indexOf(g.id) > -1
            });

            currentTermGroup = this.$store.getters.groups[currentTermGroup].id;

            const meetingToEdit = Object.assign({},this.meetingToEdit);

            meetingToEdit.participants = meetingToEdit.participants.map((p) => parseInt(p));

            if (!meetingToEdit.participants.includes(parseInt(localStorage.user_id))) {
                meetingToEdit.participants.push(parseInt(localStorage.user_id));
            }


            let session = {
                startTime: {
                    time: meetingToEdit.date.time,
                },
                meetingId: meetingToEdit.id,
                timezone: moment.tz.guess(),
                group: currentTermGroup,
                participants: meetingToEdit.participants
            }
            if (meetingToEdit.location) {
                session.location = meetingToEdit.location;
            }

            meetings.update(this, session).then(function(response) {
                if (response.data.success === true) {
                    self.$bus.$emit('reloadAlerts');

                    toastr.success('Live Session updated');

                    let title;
                    if (self.meetingToEdit.location) {
                        title = self.locations.find(function(l) { return l.id === meetingToEdit.location}).name + '\r\n';
                    } else {
                        title = "Live Session\r\n";
                    }

                    title = title + moment(self.meetingToEdit.date.time).local().format('h:mm a');

                    if (localStorage.roles.includes('Mentor')) {
                        self.meetingToEdit.participants
                        .filter(function(p) { return p != localStorage.user_id})
                        .forEach(function(p) {
                            let member = self.members.find(function(m) { return m.id == p});
                            if (member) {
                                title += "\r\n" + member.firstName + ' ' + member.lastName;
                            }
                        });
                    }

                    clientEvents[index].start = moment(self.meetingToEdit.date.time);
                    clientEvents[index].end = moment(self.meetingToEdit.date.time);
                    clientEvents[index].title = title;

                    $('#calendar').fullCalendar('updateEvent', clientEvents[index]);

                    self.meetingToEdit = null;

                } else {
                    toastr.error('Error updating session');
                }
            })
        },
        deleteMeeting() {
            var self = this;

            meetings.delete(this, this.meetingToEdit.id, this.meetingToEdit.location).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Live Session deleted');
                    $('#calendar').fullCalendar('removeEvents',self.meetingToEdit._id);
                    self.meetingToEdit = null;
                    self.$bus.$emit('reloadCheckins');

                } else {
                    toastr.error(response.data.message);
                }
            })
        },
        getGlobalMeetings() {
            return globalMeetings.getMine().then((response)=> {
                const now = new Date();

                for (let m of response.data.meetings) {

                    if (m.global_meeting) m = m.global_meeting;
                    const participant = m.global_meeting_participants.find(p => p.userId == localStorage.user_id)

                    if (participant && participant.waitListed) {
                        continue;
                    }


                    let meetingType;

                    m.mentor.roles.includes('Recruiter') ? meetingType = 'Recruiter ' : meetingType = 'Global Mentor';

                    let meetingTime = moment(m.startTime).format('h:mm a');

                    const diff = moment(m.startTime).diff(new Date(),'hours');

                    if (diff <= 12 && m.global_meeting_participants.length === 0) {
                        meetingTime = 'cancelled';
                    }

                    let title =  meetingType + ' Meeting ' + meetingTime;

                    if (m.mentor) {
                        title = meetingType + ' Meeting with ' + m.mentor.firstName + ' ' + m.mentor.lastName + ' ' + meetingTime;
                    }


                    let meeting = {
                        id: m.id,
                        type:'meeting',
                        start: moment.tz(m.startTime,moment.tz.guess()),
                        end: moment.tz(m.endTime,moment.tz.guess()),
                        title: title,
                        color: '#3cf',
                        textColor:'#1a1a1a',
                        type:'meeting',
                        global: true
                    }

                    if (m.recordingUrl) {
                        meeting.url = m.recordingUrl;
                    } else {
                        if (meeting.end.toDate() < now) {
                            meeting.recordingProcessing = true;
                        } else {
                            meeting.url = m.joinUrl;
                        }
                    }


                    this.calendarEvents.push(meeting);

                    $('#calendar').fullCalendar('renderEvent', meeting);


                }

                $('#calendar').fullCalendar('rerenderEvents');
                return true;
            });
        },
        getMeetings() {
            var self = this;

            let studentGroups = localStorage.group.split(',').map(function(i) { return parseInt(i)});

            let currentTermGroup = this.groups.findIndex(function(g) {
                return g.term == self.currentTerm.id && studentGroups.indexOf(g.id) > -1
            });

            currentTermGroup = this.groups[currentTermGroup].id;

            meetings.get(self, currentTermGroup, 'true').then(function(response) {
                if (response.data.length === 0) {
                    // no meetings scheduled yet
                    self.eventsLoaded = true;
                    return;
                }

                var meetingsArray = response.data.meetings
                .filter(function(m) {
                    return m.participants.includes(parseInt(self.feed)) && m.group == currentTermGroup;
                })
                .map(function(m) {
                    let url;
                    let name;

                    if (m.archiveUrl) {
                        if (m.archiveStatus === 'completed') {
                            url = m.archiveUrl;
                        }
                        else if (m.archiveStatus === 'processing') {
                            name = 'Archive Processing';
                            url = m.joinUrl;
                        }
                    } else {
                        if (m.joinUrl) url = m.joinUrl;
                    }



                    if (m.location) {
                        name = self.locations.find(function(l) { return l.id === m.location}).name + '\r\n';
                    } else {
                        name = "Live Session\r\n";
                    }

                    name = name + moment(m.startTime).local().format('h:mm a');

                    if (localStorage.roles.includes('Mentor')) {
                        m.participants
                        .filter(function(p) { return p != localStorage.user_id})
                        .forEach(function(p) {
                            let member = self.members.find(function(m) { return m.id == p});
                            if (member) name += "\r\n" + member.firstName + ' ' + member.lastName;
                        });
                    }

                    let title = `<a href="${url}" target="_blank">${name}</a>`;

                    if(m.secondaryRecordings && m.secondaryRecordings.length > 0) {
                        const data =  m.secondaryRecordings.map((r, i)=> {
                            return `,<a href="${r}" target="_blank" class="recording"> ${i + 2} </a>`
                        });
                       const spanHtml = data.join('');

                       if(spanHtml) {
                          title = `<a href="${url}" target="_blank">${name}</a>
                                    (
                                    <a href="${url}" target="_blank" class="recording">1</a>
                                     <span>
                                        ${spanHtml}
                                    </span>)`
                       }
                    };

                    let meeting = {
                        id: m.id,
                        type:'meeting',
                        group:m.group,
                        participants: m.participants,
                        start: moment(m.startTime).local().toDate(),
                        end: moment(m.startTime).add(m.duration,'minutes').toDate(),
                        title: title,
                        html: true,
                        className: "meeting"
                    }

                    if (m.location) meeting.location = m.location;


                    return meeting;
                });


                self.calendarEvents = self.calendarEvents.concat(meetingsArray);

                self.eventsLoaded = true;

            });

        },
        memberName(id) {
            let member = this.groupMembers.find(function(m) { return m.id === id});
            return member.firstName + ' ' + member.lastName;
        },
        noteColor(projectIds) {
            if (projectIds.length === 0 || !projectIds[0]) return '#363636';
            let project = this.projects.find(function(p) {
                return p.id === projectIds[0]
            })
            if (project) return project.color;
            return '#363636';
        },
        gradient(projectIds) {
            if (projectIds.length === 0) return 'linear-gradient(#363636, #363636, #363636)';

            let colors = this.projects.filter(function(p) {
                return projectIds.indexOf(p.id) > -1
            }).map(function(p) {
                return p.color;
            });
            if (colors.length < 2) return 'linear-gradient('+colors[0]+', '+colors[0]+', '+colors[0]+')';
            var gradient = tinygradient(colors);
            var css = gradient.css();

            return css;
        }
    },
    computed: {
        currentTerm() {
            return this.$store.getters.currentTerm;
        },

    }
}
</script>

<style lang="scss" scoped>

    .mentor-calendar {
        margin-bottom:2rem;
        padding:0 1.4rem;
    }
    .schedule-modal {
        display:none;
        background: #222;
        padding: 20px;
        max-width: 500px;
        margin: 19px auto 0 auto;
        position: relative;
        i {
            position: absolute;
            top:1rem;
            right:1rem;
            cursor:pointer;
        }
    }
    .edit-modal {
        position: fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:rgba(25,25,25,.75);
        z-index: 9999999999;
        display:flex;
        align-items:center;
        justify-content:center;
        form {
            background: #363636;
            padding:0 3rem;
            padding-bottom:4rem;
            .date {
                display:block;
                margin-bottom:1rem;
            }
            .buttons {
                display:flex;
                justify-content:space-around;
                margin:2rem 0;
                .delete {
                    background:red;
                }
            }
        }

    }
</style>

<style lang="scss">

    #calendar {
        .no-click {
            cursor:default;
           // pointer-events:none;
            .edit {
                cursor:pointer;
                pointer-events: auto;
            }
        }
        .fc-title {
            text-transform: capitalize;
        }
        .fc-title.gradient {
            display:inline-block;
            min-width:100%;
            padding:0 2px;
        }
        .dot {
            width:10px!important;
            height:10px!important;
            padding:0!important;
            border-radius:50%!important;
            border: none!important;
            display: block!important;
        }
       .fc-event-container {
            border:none!important;

        }
        .completed {
            opacity:.5;
        }
        .gradient .fc-content .fc-title {
            color: #1a1a1a;
        }
        .fc-title.gradient {
            color:#1a1a1a;
        }
        .fc-content {
            z-index: 1;
        }

        a.fc-event {
            &.meeting {
                color: #1a1a1a;
                background: #3cf;
                a {
                    color: #1a1a1a;
                }
            }

            position: relative;
            i.fa-pencil {
                position: absolute;
                top:2px;
                right:2px;
                z-index: 9999999999999;
            }
        }

        .recording:hover {
                font-weight: bold;
        }
    }

</style>



// WEBPACK FOOTER //
// MentorCalendar.vue?9478660a